import { getRelativeCoordinates } from "../../Pages/RenderFonts";

export const useEditorDropHandlers = ({
  layerId,
  setLayerId,
  getAtom,
  setAtom,
  getComponentType,
  canvasDimension,
  droppedComponentIds,
  setDroppedComponentIds,
  image,
  addBody,
  droppedTitleIds,
  setDroppedTitleIds,
  droppedTextIds,
  setDroppedTextIds,
  setDroppedComponentTextIds,
  scrollClaimReferencesFootnotes,
  setScrollClaimReferencesFoonotes,
  claimsArray,
  setClaimsArray,
  reusableTextIdsArray,
  setReusableTextIdsArray,
  claimReferencesFootnotes,
  setClaimReferencesFoonotes,
  makeLayerNameAllocator,
  getMaxLayerNumber,
  tempLayer,
  applyUniqueLayerNameIfDefaultText,
  syncListSelectionState,
  marker,
  draggerWidth,
  layerCompData,
  setScrollbarItems,
  setLayerCompData,
  setSelectedComponent,
  count,
  setCount,
  objSides,
  setVerticalLineFor,
  setundoFlag,
  setUndoAnimationObjFlag,
  setIsEditorOn,
  setIsEditorOnScrollbarItems,
  setMultiSelectedComps,
}) => {
  const getSuperScriptNumber = (updatedReferences) => {
    if (!getAtom?.claimReferences || !updatedReferences) return "";
    let claimSuperScript = [];
    let getAtomReferenceCount = 1;
    getAtom.claimReferences.forEach((claimReference) => {
      let referenceCount = 0;
      let isReferenceMatched = false;
      let referenceMp = new Set();
      updatedReferences.forEach((reference) => {
        reference.referenceArray.forEach((referenceElement) => {
          if (!referenceMp.has(referenceElement.documentName)) {
            referenceCount++;
          }

          if (
            !referenceMp.has(referenceElement.documentName) &&
            referenceElement.documentName === claimReference.documentName
          ) {
            claimSuperScript.push(referenceCount.toString());
            isReferenceMatched = true;
            getAtomReferenceCount--;
          }

          referenceMp.add(referenceElement.documentName);
        });
      });
      if (!isReferenceMatched) {
        claimSuperScript.push((referenceCount + getAtomReferenceCount).toString());
      }
      getAtomReferenceCount++;
    });
    claimSuperScript.sort((a, b) => a - b);
    return claimSuperScript.join(",");
  };

  const onDragOverScrollbar = (ev) => {
    ev.preventDefault();
  };

  const onDropScrollbar = (ev, id) => {
    if (layerId.type !== "Reference") {
      setIsEditorOnScrollbarItems("notClickedYet");
    }

    ev.preventDefault();
    let coOrdinates = getRelativeCoordinates(ev);
    const componentType = getComponentType();

    let constructObj = "";
    let constructObjFoonotes = "";
    let constructObjAbbreviation = "";

    if (layerId.type !== "") {
      constructObj = componentType[layerId.type](
        {
          x: Math.floor(coOrdinates.x / canvasDimension.scale),
          y: Math.floor(coOrdinates.y / canvasDimension.scale),
        },
        ev,
        layerId.url,
      );

      if (layerId.type === "Reference") {
        const baseX = Math.floor(coOrdinates.x / canvasDimension.scale);
        const baseY = Math.floor(coOrdinates.y / canvasDimension.scale);
        constructObjFoonotes = componentType["Footnotes"](
          { x: baseX, y: baseY - 40 },
          ev,
          layerId.url,
        );

        constructObjAbbreviation = componentType["Abbreviation"](
          { x: baseX, y: baseY },
          ev,
          layerId.url,
        );

        constructObj = componentType["Reference"](
          { x: baseX, y: baseY + 40 },
          ev,
          layerId.url,
        );
      }

      if (layerId.type === "Image") {
        return;
      }
    } else if (getAtom.type === "atomText" || getAtom.type === "Image") {
      if (getAtom.type === "Image" && getAtom.subType === "Data graphic") {
        const componentId = getAtom?.id;
        if (!droppedComponentIds.includes(componentId)) {
          setDroppedComponentIds((prev) => [...prev, componentId]);
        }
        image.componentId = getAtom?.componentId;
        image.moduleIdIdentifier = getAtom?.moduleIdIdentifier;
      }

      if (getAtom.type === "atomText") {
        if (getAtom.titleId) {
          if (!droppedTitleIds.includes(getAtom.titleId)) {
            setDroppedTitleIds((prev) => [...prev, getAtom.titleId]);
          }
          addBody.froalaText = getAtom.data;
          addBody.titleId = getAtom.titleId;
        } else if (getAtom.subType === "DataGraphicText") {
          const textId = getAtom?.id;
          addBody.matchTextId = textId;
          addBody.componentId = getAtom.componentId;
          addBody.footnoteSymbol = getAtom.footnoteSymbol;
          addBody.claimFootnotes = getAtom.claimFootnotes;
          addBody.claimReferences = getAtom.claimReferences;
          addBody.moduleIdIdentifier = getAtom.moduleIdIdentifier;

          if (!droppedTextIds.includes(textId)) {
            addBody.moduleIdIdentifier = getAtom.moduleIdIdentifier;
            setDroppedTextIds((prev) => [...prev, textId]);
          }

          if (getAtom.matchTextId) {
            addBody.moduleIdIdentifier = getAtom.moduleIdIdentifier;
            setDroppedComponentTextIds((prev) => [
              ...prev,
              {
                componentId: getAtom.componentId,
                matchTextId: getAtom.matchTextId,
              },
            ]);
          }

          const updatedMatchFootnotes = [
            ...(scrollClaimReferencesFootnotes.footnotes || []),
          ];
          const updatedMatchReferences = [
            ...(scrollClaimReferencesFootnotes.references || []),
          ];
          const updatedMatchAbbreviation = [
            ...(scrollClaimReferencesFootnotes.abbreviation || []),
          ];

          if (getAtom.claimFootnotes) {
            getAtom.footnoteSymbol.forEach((symbol, index) => {
              updatedMatchFootnotes.push({
                matchTextId: getAtom.matchTextId,
                componentId: getAtom.componentId,
                footnotesText: getAtom.claimFootnotes[index],
                footnoteSymbol: symbol,
              });
            });
          }

          if (getAtom.claimReferences?.length) {
            addBody.claimReferences = getAtom.claimReferences;
            updatedMatchReferences.push({
              matchTextId: textId,
              componentId: getAtom.componentId,
              referenceArray: getAtom.claimReferences,
            });
          }

          if (getAtom.claimAbbreviation) {
            const abbreviationSplit = getAtom.claimAbbreviation.split(";");
            abbreviationSplit.forEach((abbreviation) => {
              if (abbreviation) {
                updatedMatchAbbreviation.push({
                  matchTextId: textId,
                  componentId: getAtom?.componentId,
                  abbreviationText: abbreviation.trim(),
                });
              }
            });
          }

          setScrollClaimReferencesFoonotes({
            footnotes: updatedMatchFootnotes,
            references: updatedMatchReferences,
            abbreviation: updatedMatchAbbreviation,
          });
        }

        if (getAtom.claimId) {
          addBody.claimFootnotes = getAtom.claimFootnotes;
          addBody.claimAbbreviation = getAtom.claimAbbreviation;
          addBody.footnoteSymbol = getAtom.footnoteSymbol;
          addBody.claimReferences = getAtom.claimReferences;
          addBody.claimId = getAtom.claimId;
          addBody.rcClaimIds = getAtom.rcClaimIds;
          addBody.matchTextSymbol = getAtom.matchTextSymbol;
          addBody.rcSybmols = [];
          addBody.moduleIdIdentifier = getAtom.moduleIdIdentifier;

          setClaimsArray([...claimsArray, getAtom.claimId]);

          const updatedFootnotes = [
            ...(scrollClaimReferencesFootnotes.footnotes || []),
          ];
          const updatedReferences = [
            ...(scrollClaimReferencesFootnotes.references || []),
          ];
          const updatedAbbreviation = [
            ...(scrollClaimReferencesFootnotes.abbreviation || []),
          ];

          if (getAtom.claimFootnotes) {
            getAtom.footnoteSymbol.forEach((symbol, index) => {
              updatedFootnotes.push({
                claimId: getAtom.claimId,
                footnotesText: getAtom.claimFootnotes[index],
                footnoteSymbol: symbol,
              });
            });
          }

          if (getAtom.claimReferences?.length) {
            updatedReferences.push({
              claimId: getAtom.claimId,
              referenceArray: getAtom.claimReferences,
            });
          }

          if (getAtom.claimAbbreviation) {
            const abbreviationSplit = getAtom.claimAbbreviation.split(";");
            abbreviationSplit.forEach((abbreviation) => {
              if (abbreviation) {
                updatedAbbreviation.push({
                  claimId: getAtom.claimId,
                  abbreviationText: abbreviation.trim(),
                });
              }
            });
          }

          setScrollClaimReferencesFoonotes({
            footnotes: updatedFootnotes,
            references: updatedReferences,
            abbreviation: updatedAbbreviation,
          });
        }

        if (getAtom.titleId) {
          addBody.froalaText = getAtom.data;
        } else if (getAtom.claimId) {
          let updatedReferences = [
            ...(scrollClaimReferencesFootnotes.references || []),
          ];
          if (getAtom.claimReferences?.length) {
            updatedReferences.push({
              claimId: getAtom.claimId,
              referenceArray: getAtom.claimReferences,
            });
          }
          const superScript = ` <sup>${getAtom.footnoteSymbol || ""}${
            getAtom.footnoteSymbol?.length && getAtom.claimReferences.length
              ? ","
              : ""
          }${
            getAtom.claimReferences.length
              ? getSuperScriptNumber(updatedReferences)
              : ""
          }</sup>`;
          addBody.froalaText = getAtom.data + superScript;
        } else if (getAtom?.matchTextId) {
          if (getAtom?.subtype2 === "relatedReusabletext") {
            addBody.froalaText = getAtom.data;
            addBody.moduleIdIdentifier = getAtom.moduleIdIdentifier;
          } else {
            let updatedReferences = [
              ...(scrollClaimReferencesFootnotes.references || []),
            ];
            if (getAtom.claimReferences?.length) {
              updatedReferences.push({
                claimId: getAtom.claimId,
                referenceArray: getAtom.claimReferences,
              });
            }
            const superScript = ` <sup>${getAtom?.footnoteSymbol || ""}${
              getAtom?.footnoteSymbol?.length && getAtom.claimReferences.length
                ? ","
                : ""
            }${
              getAtom.claimReferences.length
                ? getSuperScriptNumber(updatedReferences)
                : ""
            }</sup>`;
            addBody.froalaText = getAtom.data + superScript;
          }
        } else {
          addBody.froalaText = getAtom.data;
          addBody.reusableTextId = getAtom.reusableTextId;
          addBody.moduleIdIdentifier = getAtom.moduleIdIdentifier;
          setReusableTextIdsArray([...reusableTextIdsArray, getAtom.reusableTextId]);
        }

        addBody.height = 50;
        addBody.fontSize = 10;

        let temp = getAtom.type === "atomText" ? "addBody" : getAtom.type;
        constructObj = componentType[temp](
          {
            x: Math.floor(coOrdinates.x / canvasDimension.scale),
            y: Math.floor(coOrdinates.y / canvasDimension.scale),
          },
          ev,
          addBody,
        );

        if (getAtom.titleId) {
          constructObj.titleId = getAtom.titleId;
        }

        setAtom({
          eventDetails: "",
          type: "",
          data: "",
        });

        addBody.froalaText = "Description";
        addBody.height = 50;
      } else {
        constructObj = componentType[getAtom.type](
          {
            x: Math.floor(coOrdinates.x / canvasDimension.scale),
            y: Math.floor(coOrdinates.y / canvasDimension.scale),
          },
          ev,
          getAtom.data,
        );
        return;
      }

      addBody.claimId = "";
      addBody.matchTextId = "";
      addBody.componentId = "";
      image.componentId = "";
      addBody.reusableTextId = "";
      addBody.titleId = "";
      addBody.rcClaimIds = [];
      addBody.matchTextSymbol = "";
      addBody.moduleIdIdentifier = "";
      image.moduleIdIdentifier = "";
    } else {
      return;
    }

    const alloc = makeLayerNameAllocator((base) =>
      getMaxLayerNumber(base, tempLayer.current || []),
    );
    if (layerId.type === "Reference") {
      applyUniqueLayerNameIfDefaultText(constructObj, alloc);
      applyUniqueLayerNameIfDefaultText(constructObjFoonotes, alloc);
      applyUniqueLayerNameIfDefaultText(constructObjAbbreviation, alloc);
    } else {
      applyUniqueLayerNameIfDefaultText(constructObj, alloc);
    }

    syncListSelectionState(constructObj);
    syncListSelectionState(constructObjFoonotes);
    syncListSelectionState(constructObjAbbreviation);

    constructObj.animationApllied = {
      keyFrameEdited: "false",
      keyFrameadded: "false",
      keyFrameDeleted: "false",
      componentAdded: "true",
      keyFramePasted: "false",
      marker: marker,
    };

    constructObj.componentStyles.layerWidth = draggerWidth;

    const scrollbarComp = layerCompData.find(
      (comp) => comp.componentType === "Scrollbar" && comp.id === id,
    );

    if (scrollbarComp) {
      if (layerId.type === "Reference") {
        setScrollbarItems([
          ...(scrollbarComp.scrollbarComponents || []),
          constructObjFoonotes,
          constructObjAbbreviation,
          constructObj,
        ]);
      } else {
        setScrollbarItems([...(scrollbarComp.scrollbarComponents || []), constructObj]);
      }
    }

    setLayerCompData((prevData) =>
      prevData.map((comp) =>
        comp.componentType === "Scrollbar" && comp.id === id
          ? {
              ...comp,
              scrollbarComponents: [
                ...(comp.scrollbarComponents || []),
                ...(layerId.type === "Reference"
                  ? [constructObjFoonotes, constructObjAbbreviation, constructObj]
                  : [constructObj]),
              ],
            }
          : comp,
      ),
    );

    setSelectedComponent(constructObj);
    setCount(count + 1);

    setLayerId({
      eventDetails: "",
      type: "",
    });

    setVerticalLineFor({ ...objSides });
    setundoFlag(false);
    setUndoAnimationObjFlag(false);
  };

  const dropLayer = (ev, idvalue) => {
    ev.preventDefault();
    let coOrdinates = getRelativeCoordinates(ev);
    const componentType = getComponentType();

    let constructObj = "";
    let constructObjFoonotes = "";
    let constructObjAbbreviation = "";
    let tempLayerCompData = [...layerCompData];

    if (layerId.type !== "") {
      constructObj = componentType[layerId.type](
        {
          x: Math.floor(coOrdinates.x / canvasDimension.scale),
          y: Math.floor(coOrdinates.y / canvasDimension.scale),
        },
        ev,
        layerId.url,
      );

      if (layerId.type === "Reference") {
        const baseX = Math.floor(coOrdinates.x / canvasDimension.scale);
        const baseY = Math.floor(coOrdinates.y / canvasDimension.scale);
        constructObjFoonotes = componentType["Footnotes"](
          { x: baseX, y: baseY - 40 },
          ev,
          layerId.url,
        );

        constructObjAbbreviation = componentType["Abbreviation"](
          { x: baseX, y: baseY },
          ev,
          layerId.url,
        );

        constructObj = componentType["Reference"](
          { x: baseX, y: baseY + 40 },
          ev,
          layerId.url,
        );
      }

      if (layerId.type === "Image") {
        return;
      }
    } else if (getAtom.type === "atomText" || getAtom.type === "Image") {
      if (getAtom.type === "Image" && getAtom.subType === "Data graphic") {
        const componentId = getAtom?.id;
        if (!droppedComponentIds.includes(componentId)) {
          setDroppedComponentIds((prev) => [...prev, componentId]);
        }
        image.componentId = getAtom?.componentId;
        image.moduleIdIdentifier = getAtom?.moduleIdIdentifier;
      }

      if (getAtom.type === "atomText") {
        if (getAtom.titleId) {
          if (!droppedTitleIds.includes(getAtom.titleId)) {
            setDroppedTitleIds((prev) => [...prev, getAtom.titleId]);
          }
          addBody.titleId = getAtom.titleId;
          addBody.froalaText = getAtom.data;
        } else if (getAtom.subType === "DataGraphicText") {
          const textId = getAtom?.id;
          addBody.matchTextId = textId;
          addBody.componentId = getAtom.componentId;
          addBody.footnoteSymbol = getAtom.footnoteSymbol;
          addBody.claimFootnotes = getAtom.claimFootnotes;
          addBody.claimReferences = getAtom.claimReferences;
          addBody.claimAbbreviation = getAtom.claimAbbreviation;
          addBody.moduleIdIdentifier = getAtom.moduleIdIdentifier;

          if (!droppedTextIds.includes(textId)) {
            setDroppedTextIds((prev) => [...prev, textId]);
          }

          if (getAtom.matchTextId) {
            setDroppedComponentTextIds((prev) => [
              ...prev,
              {
                componentId: getAtom.componentId,
                matchTextId: getAtom.matchTextId,
              },
            ]);
          }

          const updatedMatchFootnotes = [
            ...(claimReferencesFootnotes.footnotes || []),
          ];
          const updatedMatchReferences = [
            ...(claimReferencesFootnotes.references || []),
          ];
          const updatedAbbreviation = [
            ...(claimReferencesFootnotes.abbreviation || []),
          ];

          if (getAtom.claimFootnotes) {
            getAtom.footnoteSymbol.forEach((symbol, index) => {
              updatedMatchFootnotes.push({
                matchTextId: getAtom.matchTextId,
                componentId: getAtom?.componentId,
                footnotesText: getAtom.claimFootnotes[index],
                footnoteSymbol: symbol,
              });
            });
          }

          if (getAtom.claimReferences?.length) {
            addBody.claimReferences = getAtom.claimReferences;
            updatedMatchReferences.push({
              matchTextId: textId,
              componentId: getAtom?.componentId,
              referenceArray: getAtom.claimReferences,
            });
          }

          if (getAtom.claimAbbreviation) {
            addBody.claimAbbreviation = getAtom.claimAbbreviation;
            const abbreviationSplit = getAtom.claimAbbreviation.split(";");
            abbreviationSplit.forEach((abbreviation) => {
              if (abbreviation) {
                updatedAbbreviation.push({
                  matchTextId: textId,
                  componentId: getAtom?.componentId,
                  abbreviationText: abbreviation.trim(),
                });
              }
            });
          }

          setClaimReferencesFoonotes({
            footnotes: updatedMatchFootnotes,
            references: updatedMatchReferences,
            abbreviation: updatedAbbreviation,
          });
        }

        if (getAtom.claimId) {
          addBody.moduleIdIdentifier = getAtom.moduleIdIdentifier;
          addBody.claimFootnotes = getAtom.claimFootnotes;
          addBody.footnoteSymbol = getAtom.footnoteSymbol;
          addBody.claimAbbreviation = getAtom.claimAbbreviation;
          addBody.claimReferences = getAtom.claimReferences;
          addBody.claimId = getAtom.claimId;
          addBody.rcClaimIds = getAtom.rcClaimIds;
          addBody.matchTextSymbol = getAtom.matchTextSymbol;
          addBody.rcSybmols = [];
          setClaimsArray([...claimsArray, getAtom.claimId]);

          const updatedFootnotes = [
            ...(claimReferencesFootnotes.footnotes || []),
          ];
          const updatedReferences = [
            ...(claimReferencesFootnotes.references || []),
          ];
          const updatedAbbreviation = [
            ...(claimReferencesFootnotes.abbreviation || []),
          ];

          if (getAtom.claimFootnotes) {
            getAtom.footnoteSymbol.forEach((symbol, index) => {
              updatedFootnotes.push({
                claimId: getAtom.claimId,
                footnotesText: getAtom.claimFootnotes[index],
                footnoteSymbol: symbol,
              });
            });
          }

          if (getAtom.claimReferences?.length) {
            addBody.claimReferences = getAtom.claimReferences;
            updatedReferences.push({
              claimId: getAtom.claimId,
              referenceArray: getAtom.claimReferences,
            });
          }

          if (getAtom.claimAbbreviation) {
            addBody.claimAbbreviation = getAtom.claimAbbreviation;
            const abbreviationSplit = getAtom.claimAbbreviation.split(";");
            abbreviationSplit.forEach((abbreviation) => {
              if (abbreviation) {
                updatedAbbreviation.push({
                  claimId: getAtom.claimId,
                  abbreviationText: abbreviation.trim(),
                });
              }
            });
          }

          setClaimReferencesFoonotes({
            footnotes: updatedFootnotes,
            references: updatedReferences,
            abbreviation: updatedAbbreviation,
          });
        }

        if (getAtom.titleId) {
          addBody.froalaText = getAtom.data;
        } else if (getAtom.claimId) {
          let updatedReferences = [...(claimReferencesFootnotes.references || [])];
          if (getAtom.claimReferences?.length) {
            updatedReferences.push({
              claimId: getAtom.claimId,
              referenceArray: getAtom.claimReferences,
            });
          }
          const superScript = ` <sup>${getAtom.footnoteSymbol || ""}${
            getAtom.footnoteSymbol?.length && getAtom.claimReferences.length
              ? ","
              : ""
          }${
            getAtom.claimReferences.length
              ? getSuperScriptNumber(updatedReferences)
              : ""
          }</sup>`;
          addBody.froalaText = getAtom.data + superScript;
        } else if (getAtom?.matchTextId) {
          if (getAtom?.subtype2 === "relatedReusabletext") {
            addBody.froalaText = getAtom.data;
            addBody.moduleIdIdentifier = getAtom.moduleIdIdentifier;
          } else {
            let updatedReferences = [...(claimReferencesFootnotes.references || [])];
            if (getAtom.claimReferences?.length) {
              updatedReferences.push({
                claimId: getAtom.claimId,
                referenceArray: getAtom.claimReferences,
              });
            }
            const superScript = ` <sup>${getAtom?.footnoteSymbol || ""}${
              getAtom?.footnoteSymbol?.length &&
              getAtom?.claimReferences?.length
                ? ","
                : ""
            }${
              getAtom?.claimReferences?.length
                ? getSuperScriptNumber(updatedReferences)
                : ""
            }</sup>`;
            addBody.froalaText = getAtom.data + superScript;
          }
        } else {
          addBody.froalaText = getAtom.data;
          addBody.reusableTextId = getAtom.reusableTextId;
          addBody.moduleIdIdentifier = getAtom.moduleIdIdentifier;
          setReusableTextIdsArray([...reusableTextIdsArray, getAtom.reusableTextId]);
        }

        addBody.height = 50;
        addBody.fontSize = 10;

        let temp = getAtom.type === "atomText" ? "addBody" : getAtom.type;
        addBody.assetId = getAtom.id;

        constructObj = componentType[temp](
          {
            x: Math.floor(coOrdinates.x / canvasDimension.scale),
            y: Math.floor(coOrdinates.y / canvasDimension.scale),
          },
          ev,
          addBody,
        );

        if (getAtom.titleId) {
          constructObj.titleId = getAtom.titleId;
        }

        setAtom({
          eventDetails: "",
          type: "",
          data: "",
        });

        addBody.froalaText = "Description";
        addBody.height = 50;
      } else {
        constructObj = componentType[getAtom.type](
          {
            x: Math.floor(coOrdinates.x / canvasDimension.scale),
            y: Math.floor(coOrdinates.y / canvasDimension.scale),
          },
          ev,
          getAtom.data,
        );
        return;
      }

      addBody.claimId = "";
      addBody.matchTextId = "";
      addBody.componentId = "";
      image.componentId = "";
      addBody.reusableTextId = "";
      addBody.titleId = "";
      addBody.rcClaimIds = [];
      addBody.matchTextSymbol = "";
      addBody.moduleIdIdentifier = "";
      image.moduleIdIdentifier = "";
    } else {
      return;
    }

    const alloc = makeLayerNameAllocator((base) =>
      getMaxLayerNumber(base, tempLayer.current || []),
    );
    if (layerId.type === "Reference") {
      applyUniqueLayerNameIfDefaultText(constructObj, alloc);
      applyUniqueLayerNameIfDefaultText(constructObjFoonotes, alloc);
      applyUniqueLayerNameIfDefaultText(constructObjAbbreviation, alloc);
    } else {
      applyUniqueLayerNameIfDefaultText(constructObj, alloc);
    }

    syncListSelectionState(constructObj);
    syncListSelectionState(constructObjFoonotes);
    syncListSelectionState(constructObjAbbreviation);

    constructObj.animationApllied = {
      keyFrameEdited: "false",
      keyFrameadded: "false",
      keyFrameDeleted: "false",
      componentAdded: "true",
      keyFramePasted: "false",
      marker: marker,
    };

    constructObj.componentStyles.layerWidth = draggerWidth;

    if (layerId.type === "Reference") {
      setLayerCompData([
        constructObjFoonotes,
        constructObjAbbreviation,
        constructObj,
        ...tempLayerCompData,
      ]);
    } else {
      setLayerCompData([constructObj, ...tempLayerCompData]);
    }

    if (layerId.type !== "Reference") {
      setSelectedComponent(constructObj);
    }

    setCount(count + 1);
    setLayerId({
      eventDetails: "",
      type: "",
    });

    setMultiSelectedComps([]);
    setVerticalLineFor({ ...objSides });
    setIsEditorOn("notClickedYet");
    setundoFlag(false);
    setUndoAnimationObjFlag(false);
  };

  return { onDropScrollbar, onDragOverScrollbar, dropLayer };
};
